/**
 * /dashboard — thin role router.
 * Renders the dashboard matching the user's PRIMARY role, by precedence:
 *   ADMIN > DOCTOR > NURSE > BILLING > QA > PATIENT > ORGANIZATION
 */
import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { primaryRole } from './shared';
import AdminDashboard from './AdminDashboard';
import PatientDashboard from './roles/PatientDashboard';
import NurseDashboard from './roles/NurseDashboard';
import DoctorDashboard from './roles/DoctorDashboard';
import FinanceDashboard from './roles/FinanceDashboard';
import QADashboard from './roles/QADashboard';
import PartnerDashboard from './roles/PartnerDashboard';

export default function Dashboard() {
  const { user } = useAuth() || {};
  const role = primaryRole(user?.roles);

  switch (role) {
    case 'ADMIN':        return <AdminDashboard />;
    case 'DOCTOR':       return <DoctorDashboard />;
    case 'NURSE':        return <NurseDashboard />;
    case 'BILLING':      return <FinanceDashboard />;
    case 'QA':           return <QADashboard />;
    case 'ORGANIZATION': return <PartnerDashboard />;
    case 'PATIENT':
    default:             return <PatientDashboard />;
  }
}
